export const enumToObjectArray = (
  tsEnum: never
): { id: number; name: string }[] => {
  return Object.keys(tsEnum)
    .filter(key => !isNaN(+key))
    .map(key => ({ id: +key, name: tsEnum[key] }));
};
